<template>
  <div class="flip">
    <a @click="prevPage">上一页</a>
    <p>
      当前第
      <span>{{ currentPage }}</span>
      页，共
      <span>{{ totalPage }}</span>
      页
    </p>
    <a @click="nextPage">下一页</a>
    <p>跳转至</p>
    <input v-model="jumpPage" placeholder="页数" />
    <p>页</p>
    <a @click="toJumpPage">GO</a>
  </div>
</template>

<script>
export default {
  name: "flip",
  data() {
    return {
      jumpPage: 0
    };
  },
  props: ["currentPage", "totalPage"],
  watch: {
    nowPage(newVal) {
      this.jumpPage = newVal;
    }
  },
  computed: {
    nowPage() {
      const val = this.$props.currentPage;
      return val;
    }
  },
  created() {
    this.jumpPage = this.$props.currentPage;
  },
  methods: {
    prevPage() {
      const that = this;
      that.$emit("changePage", that.nowPage - 1);
    },
    nextPage() {
      const that = this;
      that.$emit("changePage", that.nowPage + 1);
    },
    toJumpPage() {
      const that = this;
      that.$emit("changePage", that.jumpPage);
    }
  }
};
</script>

<style scoped>
.flip {
  width: 1160px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}
.flip p {
  font-size: 16px;
  margin-right: 15px;
  line-height: 24px;
}
.flip p span {
  color: #0588cd;
}
.flip a {
  font-size: 16px;
  line-height: 24px;
  padding: 0 10px;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  margin-right: 15px;
}
.flip a:hover {
  background-color: #0588cd;
  color: white;
  border: 1px solid #0588cd;
}
.flip input {
  font-size: 16px;
  line-height: 24px;
  padding: 0 10px;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  margin-right: 15px;
  width: 40px;
}
</style>
